import { Input } from 'antd'
import CIMSFormItem from 'components/CIMSFormItem'
import { IsRequired } from './types'
import { HelpMessage } from 'utils/constants'
import { CIMSFormItemProps } from 'components/CIMSFormItem/types'
import { useDisabledOptions } from 'hooks/useDisabledOptions'

const LocationFormItem: React.FC<
  IsRequired & Pick<CIMSFormItemProps, 'disabled'>
> = ({ required = false, disabled }) => {
  const [options, { some }] = useDisabledOptions(disabled)
  return (
    <CIMSFormItem
      name="location"
      label="Location"
      requiredMessage={required ? 'Please enter a location' : undefined}
      disabled={options}
      help={HelpMessage.FieldDesignChanges.FDCTracker.Location}
    >
      <Input disabled={some} allowClear />
    </CIMSFormItem>
  )
}

export default LocationFormItem
